<template>
  <div>
    <div ref="dsc"></div>
  </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: ''
        }
    },
    watch: {
        value() {
            this.executeUserCode()
        }
    },
    mounted() {
        this.executeUserCode();
    },
    methods: {
        executeUserCode() {
            if (!this.value){
                return;
            }

            const container = this.$refs.dsc;
            while (container.firstChild) {
                container.removeChild(container.firstChild);
            }

            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.textContent = this.value; 
            container.appendChild(script);
        }
    }
};
</script>